import React, { useState, useEffect } from "react";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { getOlShops } from "../../../../services/sales/olshopService";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import ContentLayout from "../../../../partials/content/ContentLayout";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function OnlineShop({ history }) {
  const { reload } = useGlobalData();
  const [olShops, setOlShops] = useState();
  useEffect(() => {
    getOlShopsData();
  }, [reload]);
  return (
    <React.Fragment>
      <PageSubHeader
        title="Online Shop List"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/sales/online-shop",
            title: "Online Shop List",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "New Online Shop",
            color: "primary",
            icon: "fas fa-plus-circle",
            onClick: () => {
              history.push("/sales/online-shop-form");
            },
          },
        ]}
      />
      <ContentLayout>
        <CustomDataTable
          data={olShops}
          onRefreshData={() => {}}
          columns={[
            {
              header: "Online Shop ID",
              field: "ID",
              body: null,
              sortable: true,
              filter: true,
            },
            {
              header: "Domain",
              field: "domainName",
              body: null,
              sortable: true,
              filter: true,
            },
            {
              header: "Shop Name",
              field: "shopName",
              body: null,
              sortable: true,
              filter: true,
            },
            {
              header: "Currency",
              field: "currencyCode",
              body: null,
              sortable: true,
              filter: true,
            },
            {
              header: "Actions",
              body: (rowData) => (
                <React.Fragment>
                  <BootstrapTooltip title="Ol Shop Detail">
                    <button
                      type="button"
                      onClick={() => {}}
                      className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                    >
                      <i className="fas fa-list-alt"></i>
                    </button>
                  </BootstrapTooltip>
                </React.Fragment>
              ),
              sortable: false,
            },
          ]}
        />
      </ContentLayout>
    </React.Fragment>
  );
  async function getOlShopsData() {
    const response = await getOlShops();
    const { data } = response.data;
    setOlShops(data.olShops);
  }
}

export default OnlineShop;
